import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { theme, color as colors } from "@workboard/wobo-ui";
import Stats from "../components/Okrs/components/Stats";
import Teams from "../components/Okrs/components/Teams";
import Groups from "../components/Okrs/components/Groups";
import { getQuarters } from "../services/teams";
import { get } from "../services/okrs";

const Title = styled("h1")``;
const Content = styled("section")``;
const Filters = styled("div")``;

const OKRS = ({ className }) => {
  const { t } = useTranslation();
  const mountedRef = useRef(true);
  const [options, setOptions] = useState([]);
  const [{ functionalTeams, workingGroups, ...stats }, setOkrs] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [isOpenOKRs, setIsOpenOKRs] = useState(true);
  const [isClosedOKRs, setIsClosedOKRs] = useState(false);

  useEffect(() => {
    async function fetchFilters() {
      const response = await getQuarters();
      if (!mountedRef.current) return null;
      setOptions(response);
    }

    fetchFilters();
  }, [setOptions]);

  useEffect(() => {
    async function fetchOkrs() {
      const response = await get({ isOpenOKRs, isClosedOKRs, ...filters });
      if (!mountedRef.current) return null;
      setOkrs(response);
      setLoading(false);
    }

    fetchOkrs();
  }, [isOpenOKRs, isClosedOKRs, filters, setLoading, setOkrs]);

  const handleFilter = useCallback(
    f => {
      if (f.hasOwnProperty('openOKRs')) setIsOpenOKRs(f.openOKRs);
      if (f.hasOwnProperty('closedOKRs')) setIsClosedOKRs(f.closedOKRs);
      if (f.hasOwnProperty('filterOKRs')) setFilters(f.filterOKRs);
    },
    [setIsOpenOKRs, setIsClosedOKRs, setFilters]
  );

  return (
    <div className={className}>
      <Title>{t('OKRs')}</Title>
      <Content>
        <Stats options={options} onChange={handleFilter} {...stats} />
        <Teams teams={functionalTeams}/>
        <Groups groups={workingGroups}/>
      </Content>
    </div>
  );
};

export default styled(OKRS)`
  ${Title} {
    padding: 30px 0 0 24px;
    color: ${colors("--black-opacity-84")};
    font-size: 20px;
    font-weight: bold;
  }
  ${Content} {
    background: #f1f3f5;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    padding: 28px 24px;
    grid-gap: 16px 40px;
    font-family: ${theme("--font")};
    font-weight: bold;
  
    ${Stats} {
      grid-column: 1 / span 6;
      grid-row: 1 / span 3;
      grid-gap: 0;
  
      ${Filters} {
        align-items: center;
        display: flex;
        justify-content: space-between;
      }
    }
  
    ${Teams} {
      grid-column: span 3;
      grid-row: 1;
    }
  
    ${Groups} {
      grid-column: 7 / span 3;
      grid-row: 2;
    }
  }
`;
